import React, { useEffect, useState, useRef } from 'react'


var imageArray = [];
const ImageCanvas = ({ scrollHeight, numFrames, width, height }) => {


const getCurrentFrame = (index) => {
  	return `${process.env.PUBLIC_URL}/assets/books/sequence/books${index
    .toString()
    .padStart(3, "0")}.jpg`;
}
    // console.log('Shyam')
    const canvasRef = useRef(null);
  	const [images, setImages] = useState([]);
  	const [frameIndex, setFrameIndex] = useState(0);

	useEffect(() => {
		const preloadImages = () => {
			for (let i = 1; i <= numFrames; i++) {
				const img = new Image();
				const imgSrc = getCurrentFrame(i);
				img.src = imgSrc;
				imageArray.push(img);
				setImages((prevImages) => [...prevImages, img]);
                // console.log('I am called ', i, ' times')
			}
		};

		const handleScroll = () => {
			const scrollFraction = window.scrollY / (scrollHeight - window.innerHeight);
			const index = Math.min(numFrames - 1, Math.ceil(scrollFraction * numFrames));

			if (index <= 0 || index > numFrames) {
				return;
			}

			setFrameIndex(index);
		};

		const renderCanvas = () => {
			const context = canvasRef.current.getContext("2d");
			// console.log(width);
			context.canvas.width = width <= 2300 ? width : 2300;
			context.canvas.height = height;
		};

		preloadImages();
		renderCanvas();
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [height, numFrames, scrollHeight, width]);

	useEffect(() => {
		if (!canvasRef.current || images.length < 1) {
			return;
		}

		const context = canvasRef.current.getContext("2d");
		let requestId;

		const render = () => {
			context.drawImage(imageArray[frameIndex],0,0);
			requestId = requestAnimationFrame(render);
		};

		const handleResize = (e) => {
			context.canvas.height = window.innerHeight;
			context.canvas.width = window.innerWidth;
		}

		handleResize();
		window.addEventListener("resize", handleResize);

		render();

		return () => cancelAnimationFrame(requestId);
	}, [frameIndex, images]);

  return (
    <>
     <div className="scroll-sequence" style={{heigh:scrollHeight}}>
		<div className="sequence-container">
			<div className="image-sequence">
				<div className="canvas-container">
					<div className="canvas-wrapper" style={{height: '-webkit-fill-available', width:'-webkit-fill-available', zIndex:10}}>
						<canvas style={{ width:'-webkit-fill-available', transform: 'matrix(1, 0, 0, 1, 0, 0)'  }} ref={canvasRef} />
					</div>
				</div>
			</div>
		</div>
      </div>
      
    </>
  )
}

export default ImageCanvas
